import styled from 'styled-components';

import { color, spacing, typography, media } from '~/theme';

const VersionTag = styled.span`
    border-radius: 4px;
    background: ${color.tagBG};
    color: ${color.palette.white};
    display: inline-block;
    font-family: ${typography.fontSecondary};
    font-weight: ${typography.fontWeightBold};
    letter-spacing: ${typography.letterSpacingMedium};
    padding: ${spacing.spacing1} ${spacing.spacing3};

    @media ${media.small} {
        letter-spacing: ${typography.letterSpacingLarge};
    }
`;

export default VersionTag;
